import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { Dialog, DialogContent, Typography, Button, Box } from '@mui/material';

const RegCompletePopUp = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogContent
        sx={{
          py: 5,
          px: 4,
          textAlign: 'center',
        }}
      >
        <Box
          sx={{
            width: 90,
            height: 90,
            borderRadius: '50%',
            bgcolor: '#22c55e',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: 3,
            animation: 'pop 0.4s ease-out',
            '@keyframes pop': {
              '0%': {
                transform: 'scale(0.5)',
                opacity: 0,
              },
              '100%': {
                transform: 'scale(1)',
                opacity: 1,
              },
            },
          }}
        >
          <CheckCircleRoundedIcon
            sx={{
              color: '#fff',
              fontSize: 56,
            }}
          />
        </Box>

        <Typography variant="h5" fontWeight={700} gutterBottom>
          Your registration was successful
        </Typography>

        <Typography
          variant="body1"
          color="text.secondary"
          sx={{
            mb: 4,
          }}
        >
          E-ticket will be sent via email.
        </Typography>

        <Button
          variant="contained"
          fullWidth
          size="large"
          onClick={onClose}
          sx={{
            borderRadius: 2,
            py: 1.3,
            textTransform: 'none',
            fontWeight: 600,
          }}
        >
          OK
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default RegCompletePopUp;
